import { getFeaturesEnabled } from "@/utils";
export const usePriceDropVariant = () => {
    const { priceDropVariantB, priceDropVariantC } = getFeaturesEnabled();
    if (priceDropVariantB) {
        return "b";
    }
    if (priceDropVariantC) {
        return "c";
    }
    return "a";
};
